// extracted by mini-css-extract-plugin
export var actions = "_rj-4";
export var item = "_rj-1";
export var price = "_rj-3";
export var quantity = "_rj-2";
export var table = "_rj-0";